import React from 'react';

function AboutSection() {
  return (
    <section className="about">
      <div className="container">
        <h2>About ISKCON Ujjain</h2>
        <p>ISKCON Ujjain is a prominent center for spiritual learning and devotion, dedicated to spreading the teachings of Lord Krishna as presented in the Bhagavad Gita and other Vedic scriptures.</p>
      </div>
    </section>
  );
}

export default AboutSection;
